import axios from 'axios';
import { BASE_URL } from '../components/Constant';
// eslint-disable-next-line no-undef
const config = () => ({ headers: { authorization: localStorage.getItem('token') } });
const get = (path, params) =>
  axios.get(`${BASE_URL}customerSms/${path}`, { ...config(), params }).then((r) => r.data.data);
const customerSmsService = {
  customers: () => get('customers'),
  conversations: () => get('conversations'),
  history: (customerId, before) => get(`conversations/${encodeURIComponent(customerId)}`, { before }),
  send: (payload) => axios.post(`${BASE_URL}customerSms/send`, payload, config()).then((r) => r.data.data)
};
export default customerSmsService;
